import Vue from "vue";
import './plugins'

import App from "./App.vue";
import router from "./router/";
import store from "./store";
import VueSession from 'vue-session';
import vuetify from './plugins/vuetify';
import Datetime from 'vue-datetime';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';
import VModal from 'vue-js-modal';
import VueMask from 'v-mask';

import "./registerServiceWorker";
import 'font-awesome/css/font-awesome.css'
import ECharts from 'vue-echarts'
import * as VueGoogleMaps from 'vue2-google-maps';
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';


Vue.config.productionTip = false;
Vue.use(VueSession)
Vue.use(Datetime)
Vue.use(VueMask);
Vue.use(PerfectScrollbar);

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCoQUJfaNmU6eEH1a8REP1oMLbCNhwzDMw',
    libraries: 'places',
    language: 'es',
    region: 'MX'
  }
});
Vue.use(VModal, {
  dynamic: true,
  dynamicDefaults: {
    clickToClose: false
  },
  injectModalsContainer: true
});

Vue.directive('draggable', {
  bind: function (el) {
    el.style.position = 'absolute';
    var startX, startY, initialMouseX, initialMouseY;

    function mousemove(e) {
      var dx = e.clientX - initialMouseX;
      var dy = e.clientY - initialMouseY;
      el.style.top = startY + dy + 'px';
      el.style.left = startX + dx + 'px';
      return false;
    }

    function mouseup() {
      document.removeEventListener('mousemove', mousemove);
      document.removeEventListener('mouseup', mouseup);
    }

    el.addEventListener('mousedown', function (e) {
      if (e.stopPropagation) e.stopPropagation();
      if (e.preventDefault) e.preventDefault();
      e.cancelBubble = true;
      e.returnValue = false;

      startX = el.offsetLeft;
      startY = el.offsetTop;
      initialMouseX = e.clientX;
      initialMouseY = e.clientY;
      document.addEventListener('mousemove', mousemove);
      document.addEventListener('mouseup', mouseup);
      return false;
    });
  }
});

Vue.component('v-chart', ECharts)
window.$ = window.jQuery = require('jquery')

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");